import "./style.less";

export default function TableFixedPeriods() {
    return {
        restrict: "E",
        scope: {
            status: "@",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            const types = [
                { name: "optaget", status: "occupied" },
                { name: "Ledig", status: "available" },
                { name: "Ikke tilgængelig", status: "unavailable" },
            ];

            const getType = (status) => {
                return types.find((type) => type.status == status);
            };

            $scope.type = getType($scope.status);
        },
    };
}
